export const moduleConfig = {
    appName: 'Świat optyki',
    isAdminEnabled: true,
    isBlogEnabled: true,
    blogHasCategory: false,
    blogHasReview: false,
    isContactEnabled: true,
    isSettingsEnabled: true,
    isDeleteUserOptionEnabled: false,
    isNewsletterEnabled: false,
    isReservationEnabled: false,
    isProductEnabled: false,
};
